<mat-expansion-panel class="item" [expanded]="allExpandState">
	<mat-expansion-panel-header class="item-cotacao" [expandedHeight]="'100%'" [collapsedHeight]="'100%'">
		<mat-panel-title class="ajuste-largura-relativa-100">
			<div [matTooltip]="getCdItem(cot)" matTooltipPosition="below">
				{{getCdItem(cot)}}
			</div>
		</mat-panel-title>
		<mat-panel-title class="esconder-3 ajuste-largura-relativa-100">
			<div *ngIf="mostrarCdFabricante" [matTooltip]="cot.solicitacaoCompraItem.item.itemProduto.cdFabricante"
				tooltip-position="below">
				{{getCdFabricante()}}
			</div>
		</mat-panel-title>
		<mat-panel-title class="esconder-1 overflow-hidden ajuste-largura-relativa-100" style="font-size: x-small;">
			<div [matTooltip]="cot.solicitacaoCompraItem.item.nmItem" tooltip-position="below" style="white-space: pre-wrap; display: inline-block; width: 100%; margin: 5px 0px;">
				{{getDescricao()}}
			</div>
		</mat-panel-title>
		<mat-panel-title class="esconder-1 ajuste-largura-relativa-100">
			<div>{{cot.solicitacaoCompraItem.item.itemProduto.marca.nmMarca}}</div>
		</mat-panel-title>

		<mat-panel-title class="esconder-1 ajuste-largura-relativa-100">
			<div>{{cot.solicitacaoCompraItem.item.classificacaoFiscal.ncm}}</div>
		</mat-panel-title>

		<mat-panel-title class="ajuste-largura-relativa-100">
			<div>{{cot.solicitacaoCompraItem.qtSolicitada}} {{unMedida}}</div>
		</mat-panel-title>

		<mat-panel-title class="esconder-2 ajuste-largura-relativa-100">
			<div>{{cdProdutoForn}}</div>
		</mat-panel-title>
	</mat-expansion-panel-header>

	<form [formGroup]="form" style="width: 100%;">
		<div class="line">
		  <mat-form-field class="mat-form-field-qtd small-font small-inputs">
			<mat-label class="mat-label">Qtde</mat-label>
			<input matInput formControlName="qtCotacao" (blur)="validarData(form.get('dtPrevisaoEntrega').value)" (input)="recalcularItem(false)" name="qtde{{cot.idGeral}}">
			<span matSuffix class="small-font-sufix">{{unMedida}}</span>
		  </mat-form-field>
		  <mat-form-field class="mat-form-field-vl-total small-font small-inputs">
			<mat-label class="mat-label">Valor Un.</mat-label>
			<input matInput formControlName="vlBruto" (blur)="validarData(form.get('dtPrevisaoEntrega').value)" (input)="onInputChange($event, 'vlBruto')" (ngModelChange)="recalcularItem(false)" name="valor{{cot.idGeral}}">
			<span matPrefix class="small-font-sufix">R$&nbsp;</span>
		  </mat-form-field>
		  <mat-form-field class="mat-form-field small-font small-inputs">
			<mat-label class="mat-label">Desconto</mat-label>
			<input matInput formControlName="pcDesconto"id="desc{{cot.idGeral}}"
				name="desc{{cot.idGeral}}" (input)="onInputChange($event, 'pcDesconto')" (ngModelChange)="recalcularItem(false)" (blur)="validaPercentual(form.get('pcDesconto').value, 'desc'+cot.idGeral)">
			<span matSuffix class="small-font-sufix">%</span>
		  </mat-form-field>
		  <mat-form-field class="mat-form-field-data-prev-entrega small-font small-inputs">
			<mat-label class="mat-label">Dt.Prev.Entrega</mat-label>
			<input matInput formControlName="dtPrevisaoEntrega" name="dtPrevEntrega" placeholder="Dt. Prev. Entrega" (input)="formatarDataPrevEntrega($event.target.value)" (blur)="validarData(form.get('dtPrevisaoEntrega').value)">
		  </mat-form-field>
		  <mat-form-field class="mat-form-field-cstorigem small-font small-inputs">
			<mat-select id="selectCstOrigem" formControlName="cstOrigem" name="cstOrigem" placeholder="CST Origem" class="select-tipo-frete mat-label" (ngModelChange)="cot.cstOrigem = form.value.cstOrigem" [required]="isStInvalid()">
			  <mat-option [value]="null">Selecione...</mat-option>
			  <mat-option [value]="'0'">0 - Nacional</mat-option>
			  <mat-option [value]="'1'">1 - Estrangeira</mat-option>
			  <mat-option [value]="'2'">2 - Estrangeira</mat-option>
			  <mat-option [value]="'3'">3 - Nacional</mat-option>
			  <mat-option [value]="'4'">4 - Nacional</mat-option>
			  <mat-option [value]="'5'">5 - Nacional</mat-option>
			  <mat-option [value]="'6'">6 - Estrangeira</mat-option>
			  <mat-option [value]="'7'">7 - Estrangeira</mat-option>
			  <mat-option [value]="'8'">8 - Nacional</mat-option>
			</mat-select>
		  </mat-form-field>
		  <mat-form-field class="mat-form-field small-font small-inputs">
			<mat-label class="mat-label">Aliq. IPI</mat-label>
			<input matInput (ngModelChange)="recalcularItem(false)" formControlName="ipiPcAliq" [value]="getFormattedVl('ipiPcAliq')" (input)="onInputChange($event, 'ipiPcAliq')" name="ipiAliq{{cot.idGeral}}">
			<span matSuffix class="small-font-sufix">%</span>
		  </mat-form-field>
		  <mat-form-field class="mat-form-field small-font small-inputs">
			<mat-label class="mat-label">Aliq. ICMS</mat-label>
			<input matInput formControlName="icmsPcAliquota" [value]="getFormattedVl('icmsPcAliquota')" (input)="onInputChange($event, 'icmsPcAliquota')" (ngModelChange)="recalcularItem(false)" name="icmsAliq{{cot.idGeral}}">
			<span matSuffix class="small-font-sufix">%</span>
		  </mat-form-field>
		  <mat-form-field class="mat-form-field small-font small-inputs">
			<mat-label class="mat-label">Vl. ICMS</mat-label>
			<input matInput formControlName="icmsValor" [value]="getFormattedVl('icmsValor')" (input)="onInputChange($event, 'icmsValor') " (ngModelChange)="recalcularItem(true)" name="icmsValor{{cot.idGeral}}">
			<span matPrefix class="small-font-sufix">R$&nbsp;</span>
		  </mat-form-field>
		  <mat-form-field class="mat-form-field small-font small-inputs">
			<mat-label class="mat-label">Aliq. ST</mat-label>
			<input matInput formControlName="icmsStPcAliquota" [value]="getFormattedVl('icmsStPcAliquota')" (input)="onInputChange($event, 'icmsStPcAliquota')" (ngModelChange)="recalcularItem(false)">
			<span matSuffix class="small-font-sufix">%</span>
		  </mat-form-field>
		  <mat-form-field class="mat-form-field small-font small-inputs">
			<mat-label class="mat-label">Vl. ST</mat-label>
			<input matInput formControlName="icmsStValor" [value]="getFormattedVl('icmsStValor')" (input)="onInputChange($event, 'icmsStValor')" (ngModelChange)="recalcularItem(true)" name="icmsValorSt{{cot.idGeral}}">
			<span matPrefix class="small-font-sufix">R$&nbsp;</span>
		  </mat-form-field>
		  <mat-form-field class="mat-form-field-vl-total small-font small-inputs">
			<mat-label class="mat-label">Vl. Total</mat-label>
			<input matInput [value]="getFormattedVl('vlTotal')" name="vlTotal{{cot.idGeral}}" disabled>
			<span matPrefix class="small-font-sufix">R$&nbsp;</span>
		  </mat-form-field>
		  <mat-form-field class="mat-form-field-observacao small-font small-inputs">
			<mat-label class="mat-label">Observação</mat-label>
			<input matInput formControlName="obs" class="obs" name="obs" (ngModelChange)="cot.obs = form.value.obs">
		  </mat-form-field>
		</div>
		<mat-select *ngIf="filiais.length > 1" formControlName="fornecedorFaturamento" placeholder="Filial" class="select-filiais">
		  <mat-option *ngFor="let f of filiais" [value]="f">{{f.nmCliente}} - {{f.cidade.uf}} - {{f.cnpjCpf}}</mat-option>
		</mat-select>
	</form>
	  

</mat-expansion-panel>